<template>
  <div>
    <nav-bar :title="'Module'"></nav-bar>
    <div class="atm-desktop-max-width mx-auto mobile">
      <header class="module--header mb-3">
        <picture v-if="skillInfo && skillInfo.icon" class="module--header--logo">
          <b-img :src="skillInfo.icon" alt="logo" rounded class="module--header--logo__img"></b-img>
        </picture>
        <picture v-else class="module--header--logo">
          <b-skeleton-img height="60px" class="module--header--logo__img"></b-skeleton-img>
        </picture>
        <div class="module--header--content">
          <h5 v-if="skillInfo.name" class="font-weight-bolder">{{ skillInfo.name }}</h5>
          <b-skeleton v-else width="100px"></b-skeleton>
          <b-progress
            class="module--header--content__progress rounded-pill"
            :max="skillInfo.lessons"
          >
            <b-progress-bar
              :value="skillInfo.progress"
              :label="`${((skillInfo.progress / skillInfo.lessons) * 100).toFixed(0)}%`"
            ></b-progress-bar>
          </b-progress>
        </div>
      </header>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { useLearnSkillsStore } from '@/common/plugins/store';
import { getSkillLessonsById } from '../services';

import { NavBar } from '@/common/components';

export default {
  components: {
    NavBar,
  },
  data() {
    const store = useLearnSkillsStore();
    return {
      store,
      skillInfo: {},
    };
  },
  async mounted() {
    this.store.resetLessons();
    try {
      const { id } = this.$route.params;
      const lessons = await getSkillLessonsById({ id });
      this.store.setLessons(lessons);
      const lessonIcon = localStorage.getItem('lessonIcon');
      this.skillInfo = {
        name: lessons[0]?.module_name || 'Title',
        icon: lessonIcon,
        lessons: lessons.length || 0,
        progress: lessons.reduce((acc, cv) => (cv.viewed ? (acc += 1) : acc), 0),
      };
    } catch (error) {
      console.error('[view]', error);
    }
  },
};
</script>
<style lang="scss" scoped>
.module--header {
  display: flex;
  &--logo {
    width: 75px;
    margin-right: 1rem;

    &__img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }

  &--content {
    width: 100%;
  }
}
</style>
